import {
  Component,
  ElementRef,
  HostListener,
  Inject,
  ViewChild,
} from '@angular/core';
import { stringsList } from '../../../constants/app-config';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { InvoiceModel } from '../../models/invoice.model';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { TemplateService, TemplateType } from '../../services/template.service';
import { BANK_STATEMENT_FIELDS, bankStatementFieldMap } from '../../../constants/bank-statement-fields';

@Component({
  selector: 'app-add-template-dialog',
  templateUrl: './add-template-dialog.component.html',
  styleUrls: ['./add-template-dialog.component.css'],
})
export class AddTemplateDialogComponent {
  public TemplateType = TemplateType;
  templateTypeCopy?: TemplateType;
  templateType: TemplateType = TemplateType.REGULAR;
  isButtonDisabled: boolean = true;
  stringsList = stringsList;
  isClosed = false;
  isLoading = false;
  previewTemplateTableContent: string[] = [];
  additionalAttributeTableValues: string[] = [];
  isPreviewTemplate = false;
  isSaveChangesDialog = false;
  isToggleChecked: any = {
    documentURL: false,
    deductibleTaxBase: false,
    deductibleVAT: false,
    nonDeductibleTaxBase: false,
    nonDeductibleVAT: false,
    total: false,
    code: false,
    ID: false,
    documentName: false,
    companyName: false,
    invoiceDate: false,
    dueDate: false,
    invoiceNumber: false,
    vatID: false,
    incomeExpenseDate: false,
    viaBankAccount: false,
    inGoodsMaterials: false,
    grossEmployeeWages: false,
    paidEntrepreneurContributions: false,
    otherExpenses: false,
    documentDescription: false,
    konto: false,
    schema: false,
    buyerName: false,
    buyerID: false,
    buyerVATID: false,
  };
  additionalParameter = {
    key: '',
    value: '',
  };
  documentIndexValue = {
    key: 'KUF No.',
    value: '',
  };
  documentIndexValueCopy;
  isDocumentIndexChecked = false;
  isDocumentIndexCheckedCopy;
  isAdditionalParameterAdded = false;
  titles: any = {
    name: '',
    description: '',
    documentIndex: '',
    documentURL: '',
    deductibleTaxBase: '',
    deductibleVAT: '',
    nonDeductibleTaxBase: '',
    nonDeductibleVAT: '',
    total: '',
    code: '',
    ID: '',
    documentName: '',
    companyName: '',
    invoiceDate: '',
    dueDate: '',
    invoiceNumber: '',
    vatID: '',
    productCode: '',
    barcode: '',
    number: '',
    productName: '',
    unit: '',
    quantity: '',
    priceWithTax: '',
    priceWithoutTax: '',
    discountPercentage: '',
    discountAmount: '',
    taxPercentage: '',
    taxAmount: '',
    retailPrice: '',
    articleCode: '',
    totalPrice: '',
    totalPriceWithoutTax: '',
    totalPriceWithoutTaxBeforeDiscount: '',
    incomeExpenseDate: '',
    viaBankAccount: '',
    inGoodsMaterials: '',
    grossEmployeeWages: '',
    paidEntrepreneurContributions: '',
    otherExpenses: '',
    documentDescription: '',
    konto: '',
    schema: '',
    buyerName: '',
    buyerID: '',
    buyerVATID: '',
    // Bank statement (izvod) row fields — goods templates only, like productCode
    ...bankStatementFieldMap(''),
  };
  isFixedValueEnabled: any = {
    ID: false,
    vatID: false,
    buyerID: false,
    buyerVATID: false
  };

  fixedValues: any = {
    ID: '',
    vatID: '',
    buyerID: '',
    buyerVATID: ''
  };

  isFixedValueEnabledCopy: any;
  fixedValuesCopy: any;

  isData = false;
  keepOriginalOrder = (a: { key: any }, b: any) => a.key;
  attributeValues: string[] = Object.keys(this.isToggleChecked);
  additionalAttributeValues: Array<{ key: string; value?: string }> = [];
  emptyHeaders: number[] = Array(0);
  saveChangesData = {
    heading: 'Discard Template?',
    contentPartOne: 'Are you sure you want to exit without saving changes? ',
    contentPartTwo: '',
    action: 'Save changes',
    contentFile: '',
  };
  isToggleCheckedCopy;
  titlesCopy;
  attributeValuesCopy;
  @ViewChild('additionalParameterInput', { static: false })
  additionalParameterInput!: ElementRef<HTMLInputElement>;

  additionalFields: string[] = [
    'productCode',
    'barcode',
    'number',
    'productName',
    'unit',
    'quantity',
    'priceWithTax',
    'priceWithoutTax',
    'discountPercentage',
    'discountAmount',
    'taxPercentage',
    'taxAmount',
    'articleCode',
    'retailPrice',
    'totalPrice',
    'totalPriceWithoutTax',
    'totalPriceWithoutTaxBeforeDiscount',
    'incomeExpenseDate',
    'viaBankAccount',
    'inGoodsMaterials',
    'grossEmployeeWages',
    'paidEntrepreneurContributions',
    'otherExpenses',
    'documentDescription',
    'buyerName',
    'buyerID',
    'buyerVATID',
    'code',
    ...BANK_STATEMENT_FIELDS,
  ];

  isEditMode: boolean = false;



  constructor(
    public dialogRef: MatDialogRef<AddTemplateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public translate: TranslateService,
    public templateService: TemplateService
  ) {
    if (this.data) {
      this.titles = this.addMissingPropertiesToObjData(this.data.template);
      this.isToggleChecked = {};
      for (const [key, value] of Object.entries(this.titles)) {
        if (
          key !== 'description' &&
          key !== 'name' &&
          key !== 'documentIndex' &&
          this.templateService.isMandatoryKey(key)
        )
          Object.assign(this.isToggleChecked, { [key]: !!value });
        else if (key === 'documentIndex') {
          this.isDocumentIndexChecked = !!value;
          if (value) {
            this.documentIndexValue.value = value as string;
          } else {
            this.documentIndexValue.value = '';
          }
        }
        else if (!this.templateService.isMandatoryKey(key)) {
          Object.assign(this.isToggleChecked, { [key]: true });
        }
      }
      this.isFixedValueEnabled = this.data.template.isFixedValueEnabled || {
        ID: false,
        vatID: false,
        buyerID: false,
        buyerVATID: false
      };
      this.fixedValues = this.data.template.fixedValues || {
        ID: '',
        vatID: '',
        buyerID: '',
        buyerVATID: ''
      };

      // Create copies for change detection
      this.isFixedValueEnabledCopy = JSON.parse(JSON.stringify(this.isFixedValueEnabled));
      this.fixedValuesCopy = JSON.parse(JSON.stringify(this.fixedValues));

      // this.attributeValues = Object.keys(this.isToggleChecked);
      this.attributeValues = Object.keys(this.isToggleChecked).filter(
        key => key !== 'isFixedValueEnabled' && key !== 'fixedValues'
      );
      this.attributeValues = this.reorderSecondArray(
        this.data.keysAsStrings,
        this.attributeValues
      );

      this.isToggleCheckedCopy = JSON.parse(
        JSON.stringify(this.isToggleChecked)
      );
      this.titlesCopy = JSON.parse(JSON.stringify(this.titles));
      this.attributeValuesCopy = JSON.parse(
        JSON.stringify(this.attributeValues)
      );
      this.documentIndexValueCopy = JSON.parse(
        JSON.stringify(this.documentIndexValue)
      );
      this.isDocumentIndexCheckedCopy = JSON.parse(
        JSON.stringify(this.isDocumentIndexChecked)
      );
      this.isData = true;

      this.templateType = this.data.templateType;
      this.templateTypeCopy = this.data.templateType;
      this.updateAttributeValues();
      this.areChangesMade();

      this.isEditMode = true;

    } else {
      this.isFixedValueEnabled = {
        ID: false,
        vatID: false,
        buyerID: false,
        buyerVATID: false
      };
      this.fixedValues = {
        ID: '',
        vatID: '',
        buyerID: '',
        buyerVATID: ''
      };
      this.isData = false;
    }
  }

  updateAttributeValues() {
    // const uniqueAttributeValues = new Set(Object.keys(this.isToggleChecked));
    const toggleKeys = Object.keys(this.isToggleChecked).filter(
      key => key !== 'isFixedValueEnabled' && key !== 'fixedValues'
    );

    const uniqueAttributeValues = new Set(toggleKeys);

    if (this.templateType === TemplateType.GOODS) {
      this.additionalFields.forEach(field => uniqueAttributeValues.add(field));
    }

    this.attributeValues = Array.from(uniqueAttributeValues);
    this.attributeValues = this.reorderSecondArray(
      this.data.keysAsStrings,
      this.attributeValues
    );
  }



  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event) { }

  areChangesMade() {
    if (this.isData) {
      this.isButtonDisabled = !this.isValidData(this.isToggleChecked);
      const trimmedTitles = this.trimmedObject(this.titles);
      const trimmedTitlesCopy = this.trimmedObject(this.titlesCopy);

      if (
        JSON.stringify(this.isToggleCheckedCopy) !==
        JSON.stringify(this.isToggleChecked)
      ) {
        return true;
      } else if (
        JSON.stringify(trimmedTitlesCopy) !== JSON.stringify(trimmedTitles)
      ) {
        return true;
      } else if (
        JSON.stringify(this.documentIndexValue) !==
        JSON.stringify(this.documentIndexValueCopy)
      ) {
        return true;
      } else if (
        JSON.stringify(this.isDocumentIndexCheckedCopy) !==
        JSON.stringify(this.isDocumentIndexChecked)
      ) {
        return true;
      } else if (
        JSON.stringify(this.attributeValuesCopy) !==
        JSON.stringify(this.attributeValues)
      ) {
        return true;
      } else if (this.templateType !== this.templateTypeCopy) {
        return true;
      } else if (
        JSON.stringify(this.isFixedValueEnabledCopy) !==
        JSON.stringify(this.isFixedValueEnabled)
      ) {
        return true;
      } else if (
        JSON.stringify(this.fixedValuesCopy) !==
        JSON.stringify(this.fixedValues)
      ) {
        return true;
      }
      return false;
    } else {
      return false;
    }
  }

  trimmedObject(obj: any): any {
    const trimmedObj: any = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        trimmedObj[key] = typeof obj[key] === 'string' ? obj[key].trim() : obj[key];
      }
    }
    return trimmedObj;
  }



  isValidData(data: any): boolean {
    // Check if the required field 'name' is present and not an empty string
    const isNameValid = this.titles['name']?.trim().length > 0;
    // Check if at least one optional field has a value
    const optionalFields = [
      'companyName',
      'deductibleTaxBase',
      'deductibleVAT',
      'documentName',
      'dueDate',
      'invoiceDate',
      'invoiceNumber',
      'nonDeductibleTaxBase',
      'nonDeductibleVAT',
      'total',
      'vatID',
      'productCode',
      'barcode',
      'number',
      'productName',
      'unit',
      'quantity',
      'priceWithTax',
      'priceWithoutTax',
      'discountPercentage',
      'discountAmount',
      'taxPercentage',
      'taxAmount',
      'articleCode',
      'retailPrice',
      'totalPrice',
      'totalPriceWithoutTax',
      'totalPriceWithoutTaxBeforeDiscount',
      'konto',
      'schema',
      'code',
      ...BANK_STATEMENT_FIELDS,
    ];
    const isAtLeastOneOptionalFieldValid = optionalFields.some(
      (field) => data[field] === true
    );
    // Return true if the required field and at least one optional field are valid
    return isNameValid && isAtLeastOneOptionalFieldValid;
  }


  addMissingPropertiesToObjData(data: InvoiceModel) {
    for (const [key, value] of Object.entries(this.titles)) {
      if (!this.data.template.hasOwnProperty(key)) {
        data[key as keyof typeof data] = value as string;
      }
    }
    return data;
  }

  addAdditionalParameter() {
    if (this.additionalParameter?.key) {
      // this.additionalAttributeValues.push({
      //   key: this.additionalParameter?.key,
      //   value: this.additionalParameter.value
      //     ? this.additionalParameter.value
      //     : '',
      // });
      this.titles[this.additionalParameter?.key] = this.additionalParameter
        ?.value
        ? this.additionalParameter?.value
        : '';
      this.isToggleChecked[this.additionalParameter?.key] = true;
      this.attributeValues.push(this.additionalParameter?.key);

      this.additionalParameter.key = '';
      this.additionalParameter.value = '';
    }
    this.isAdditionalParameterAdded = false;
  }

  removeAdditionalParameter(key: string | null) {
    delete this.titles[key!];
    delete this.isToggleChecked[key!];
    this.attributeValues = this.attributeValues.filter((el) => el !== key);
  }

  selectAll(event: any) {
    if (event.checked) {
      Object.keys(this.isToggleChecked).forEach((key) => {
        this.isToggleChecked[key] = true;
      });
    } else {
      Object.keys(this.isToggleChecked).forEach((key) => {
        this.isToggleChecked[key] = false;
      });
    }
  }

  createTemplate() {
    this.isLoading = true;
    this.dialogRef.close({
      action: stringsList.addAction,
      data: {
        titles: this.titles,
        isToggleChecked: this.isToggleChecked,
        attributeValues: this.attributeValues,
        documentIndexValue: this.documentIndexValue,
        isDocumentIndexChecked: this.isDocumentIndexChecked,
        templateType: this.templateType,
        isFixedValueEnabled: this.isFixedValueEnabled,
        fixedValues: this.fixedValues
      },
    });
  }

  saveTemplate() {
    this.dialogRef.close({
      action: stringsList.saveChanges,
      data: {
        titles: this.titles,
        isToggleChecked: this.isToggleChecked,
        attributeValues: this.attributeValues,
        documentIndexValue: this.documentIndexValue,
        isDocumentIndexChecked: this.isDocumentIndexChecked,
        templateType: this.templateType,
        isFixedValueEnabled: this.isFixedValueEnabled,
        fixedValues: this.fixedValues
      },
    });
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(
      this.attributeValues,
      event.previousIndex,
      event.currentIndex
    );
  }

  areNoCheckboxesSelected() {
    const toggleKeys = Object.keys(this.isToggleChecked).filter(key => key !== 'name' && key !== 'description' && key !== 'code');
    return toggleKeys.every(key => !this.isToggleChecked[key]);
  }

  closeAdditionalInfo() {
    this.isPreviewTemplate = false;
    this.additionalAttributeTableValues = [];
    setTimeout(() => {
      this.isClosed = false;
    }, 300);
  }

  previewTemplate() {
    this.previewTemplateTableContent = [];
    let additionalEmptyFields = 0;
    this.attributeValues.forEach((attribute) => {
      if (
        attribute !== 'name' &&
        attribute !== 'description' &&
        attribute !== 'code' &&
        attribute !== 'documentIndex'
      ) {
        {
          if (this.isToggleChecked[attribute]) {
            // Check if this is a fixed value field
            if (this.titles[attribute].length) {
              // Use the custom title
              this.additionalAttributeTableValues.push(this.titles[attribute]);
            } else {
              // Use empty string
              this.additionalAttributeTableValues.push('');
            }

            // Add the header name
            if (this.templateService.isMandatoryKey(attribute)) {
              this.previewTemplateTableContent.push(this.titles[attribute]);
            } else {
              this.previewTemplateTableContent.push(attribute);
            }
            additionalEmptyFields += 1;
          } else {
            if (attribute === 'taxBase') {
              this.previewTemplateTableContent.push('Tax base');
              additionalEmptyFields += 1;
              this.additionalAttributeTableValues.push('');
            } else {
              if (attribute === 'taxBase') {
                this.previewTemplateTableContent.push('Tax base');
                additionalEmptyFields += 1;
                this.additionalAttributeTableValues.push('');
              }
              if (attribute === 'documentURL') {
                this.previewTemplateTableContent.push('Document source');
                additionalEmptyFields += 1;
                this.additionalAttributeTableValues.push('');
              }
              if (attribute === 'vat') {
                this.previewTemplateTableContent.push('VAT');
                additionalEmptyFields += 1;
                this.additionalAttributeTableValues.push('');
              }
              if (attribute === 'total') {
                this.previewTemplateTableContent.push('Total');
                additionalEmptyFields += 1;
                this.additionalAttributeTableValues.push('');
              }
              if (attribute === 'code') {
                this.previewTemplateTableContent.push('Code');
                additionalEmptyFields += 1;
                this.additionalAttributeTableValues.push('');
              }
              if (attribute === 'dueDate') {
                this.previewTemplateTableContent.push('Due date');
                additionalEmptyFields += 1;
                this.additionalAttributeTableValues.push('');
              } else if (attribute === 'documentName') {
                this.previewTemplateTableContent.push('Document');
                additionalEmptyFields += 1;
                this.additionalAttributeTableValues.push('');
              } else if (attribute === 'companyName') {
                this.previewTemplateTableContent.push('Company');
                additionalEmptyFields += 1;
                this.additionalAttributeTableValues.push('');
              } else if (attribute === 'invoiceDate') {
                this.previewTemplateTableContent.push('Invoice date');
                additionalEmptyFields += 1;
                this.additionalAttributeTableValues.push('');
              } else if (attribute === 'invoiceNumber') {
                this.previewTemplateTableContent.push('Invoice number');
                additionalEmptyFields += 1;
                this.additionalAttributeTableValues.push('');
              } else if (attribute === 'vatID') {
                this.previewTemplateTableContent.push('VATID');
                additionalEmptyFields += 1;
                this.additionalAttributeTableValues.push('');
              } else if (attribute === 'ID') {
                this.previewTemplateTableContent.push('ID number');
                additionalEmptyFields += 1;
                this.additionalAttributeTableValues.push('');
              } else if (attribute === 'deductibleTaxBase') {
                this.previewTemplateTableContent.push('Deductible tax base');
                additionalEmptyFields += 1;
                this.additionalAttributeTableValues.push('');
              } else if (attribute === 'nonDeductibleTaxBase') {
                this.previewTemplateTableContent.push(
                  'Non-deductible tax base'
                );
                additionalEmptyFields += 1;
                this.additionalAttributeTableValues.push('');
              } else if (attribute === 'deductibleVAT') {
                this.previewTemplateTableContent.push('Deductible VAT');
                additionalEmptyFields += 1;
                this.additionalAttributeTableValues.push('');
              } else if (attribute === 'nonDeductibleVAT') {
                this.previewTemplateTableContent.push('Non-deductible VAT');
                additionalEmptyFields += 1;
                this.additionalAttributeTableValues.push('');
              } else if (attribute === 'documentIndex') {
                this.previewTemplateTableContent.push('KUF No.');
                additionalEmptyFields += 1;
                this.additionalAttributeTableValues.push('');
              } else if (!this.templateService.isMandatoryKey(attribute)) {
                this.previewTemplateTableContent.push(attribute);
                additionalEmptyFields += 1;
                this.additionalAttributeTableValues.push('');
              }
            }
          }
        }
      }
    });

    this.emptyHeaders = Array(additionalEmptyFields);
    this.additionalAttributeValues.forEach((el) => {
      this.previewTemplateTableContent.push(el.key);
    });
    this.isClosed = true;
    setTimeout(() => {
      this.isPreviewTemplate = true;
    }, 600);
  }

  closeDialog() {
    if (this.isData) {
      if (this.areChangesMade()) {
        if (this.isPreviewTemplate) {
          this.isPreviewTemplate = false;
        }
        if (!this.isSaveChangesDialog) {
          this.isClosed = true;
          setTimeout(() => {
            // this.dialogRef.close()
            this.isSaveChangesDialog = true;
          }, 600);
        } else {
          this.isSaveChangesDialog = false;
          this.dialogRef.close();
        }
      } else {
        this.isClosed = true;
        setTimeout(() => {
          this.dialogRef.close();
          // this.isSaveChangesDialog = true
        }, 600);
      }
    } else {
      if (!this.titles['name'].trim()) {
        this.isClosed = true;
        setTimeout(() => {
          this.dialogRef.close();
        }, 600);
      } else {
        if (this.isPreviewTemplate) {
          this.isPreviewTemplate = false;
        }
        if (!this.isSaveChangesDialog) {
          this.isClosed = true;
          setTimeout(() => {
            // this.dialogRef.close()
            this.isSaveChangesDialog = true;
          }, 600);
        } else {
          this.isSaveChangesDialog = false;
          this.dialogRef.close();
        }
      }
    }
  }

  reorderSecondArray(firstArray: any, secondArray: any) {
    const indexMapping = new Map();
    firstArray.forEach((element: any, index: any) => {
      indexMapping.set(element, index);
    });

    return secondArray.slice(0).sort((a: any, b: any) => {
      if (a === 'name') return -1;
      if (b === 'name') return 1;
      if (a === 'description') return -1;
      if (b === 'description') return 1;

      const indexA = indexMapping.get(a);
      const indexB = indexMapping.get(b);

      if (indexA === undefined && indexB === undefined) {
        return secondArray.indexOf(a) - secondArray.indexOf(b);
      } else if (indexA === undefined) {
        return 1;
      } else if (indexB === undefined) {
        return -1;
      } else {
        return indexA - indexB;
      }
    });
  }
}
